export const projExitBgDelay = 0.75;
export const projExitBgDuration = 1.25;
export const projExitBgEase = [0.87, 0, 0.13, 1];